import classNames from "classnames/bind"
import PropTypes from "prop-types"
import React from "react"
import { useParams } from "react-router-dom"

import useMobile from "../../hooks/useMobile"
import Internationalization from "../../views/International/Internationalization"
import Advertising from "../../views/shared/Advertising"
import CallToActionContainer from "../../views/shared/CallToActionContainer"
import CostPerTransaction from "../../views/shared/CostPerTransaction/CostPerTransaction"
import FreeOfTransactionFee from "../../views/shared/FreeOfTransactionFee"
import Pricing from "../../views/shared/Pricing"
import Returns from "../../views/shared/Returns"
import Shipping from "../../views/shared/Shipping"
import Support from "../../views/shared/Support"

import styles from "../Plans.module.css"

const cx = classNames.bind(styles)

const headerClass = cx("row", "header", "no-border")

const International = props => {
  const { data, lang, onChangePlan } = props
  const { type } = useParams()

  const plans = data?.[`${type}Plans`] || []
  const { isMobile } = useMobile()

  function renderPlans(planItems, key = "") {
    return (
      <div key={key} className={styles[type]}>
        {/* empty cell to keep the grid layout */}
        <div className={cx(headerClass, "no-bg")} />

        <Pricing plans={planItems} lang={lang} />
        <FreeOfTransactionFee plans={planItems} />
        <CostPerTransaction plans={planItems} />
        <Internationalization plans={planItems} />
        <Advertising plans={planItems} />
        <Returns plans={planItems} />
        <Shipping plans={planItems} lang={lang} />
        <Support plans={planItems} />
        <CallToActionContainer
          lang={lang}
          plans={planItems}
          onChangePlan={onChangePlan}
        />
      </div>
    )
  }

  if (isMobile) {
    return plans.map(plan => renderPlans([plan], `PLAN_${plan.id}`, false))
  }

  return renderPlans(plans)
}

International.propTypes = {
  data: PropTypes.object,
  lang: PropTypes.string,
  onChangePlan: PropTypes.func,
}
International.defaultProps = {
  data: {},
  lang: "en",
  onChangePlan: () => {},
}

export default International
